import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { merge } from 'lodash';
import {
    ContentZonesService,
    ConfigsService as GeneralConfigService,
    LocaleService,
} from '@sm360/widget-commons-core-services';
import { Translations as GeneralTranslations } from '@sm360/widget-commons-general';
import { Translations as FormTranslations } from '@sm360/widget-commons-forms';
import config from 'trade-in/config/index.js';

import OfficialTradeIn from 'trade-in/components/OfficialTradeIn/OfficialTradeIn.jsx';

import en from 'trade-in/i18n/en.json';
import fr from 'trade-in/i18n/fr.json';

class OfficialTradeInProvider extends Component {
    constructor(props) {
        super(props);

        merge(en, FormTranslations.en, GeneralTranslations.en);
        merge(fr, FormTranslations.fr, GeneralTranslations.fr);

        LocaleService.setLocale(props.locale);
        LocaleService.loadTranslations({ en, fr });

        GeneralConfigService.setLocation(props.location);
        GeneralConfigService.setWebsiteId(props.websiteId);
        GeneralConfigService.setOrganizationId(this.props.organizationId);
        GeneralConfigService.setOrganizationUnitId(this.props.organizationUnitId);
        GeneralConfigService.setOrganizationUnitLocation(this.props.organizationUnitLocation);
        ContentZonesService.setImageServerBaseUrl(config.source.image);
        ContentZonesService.addContentZones(this.props.contentZones);
    }

    render() {
        return <OfficialTradeIn />;
    }
}

OfficialTradeInProvider.displayName = 'OfficialTradeInProvider';

OfficialTradeInProvider.propTypes = {
    locale: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    websiteId: PropTypes.number.isRequired,
    organizationUnitId: PropTypes.number.isRequired,
    organizationId: PropTypes.number.isRequired,
    organizationUnitLocation: PropTypes.string.isRequired,
    contentZones: PropTypes.objectOf(
        PropTypes.arrayOf(
            PropTypes.shape({
                active: PropTypes.bool,
                group: PropTypes.string,
                id: PropTypes.number,
                location: PropTypes.string,
                position: PropTypes.number,
                type: PropTypes.string,
                value: PropTypes.string,
            })
        )
    ).isRequired,
};

export default OfficialTradeInProvider;
